import { useToastStore, type ToastType } from '~/stores/toast'
import { storeToRefs } from 'pinia'

export const useToast = () => {
  const store = useToastStore()
  const { toasts } = storeToRefs(store)

  return {
    toasts,
    add: (message: string, type: ToastType = 'success', duration: number = 3500) =>
      store.add({ message, type, duration }),
    remove: store.remove,
  }
}
